import { useMemo } from "react";
import { useQuery } from "react-query";
import { getAgencySettings } from "../queries/agencySettings";
import useNetworkHeaders from "./useNetworkHeaders";
import useSite from "../features/permits/components/inspections/InspectionPanel/useSite";

export const useClient = (site?: string) => {
  const defaultSite = useSite();
  site ||= defaultSite;
  const headers = useNetworkHeaders();
  const clientQuery = useQuery(["clients", site], getAgencySettings(headers), {
    enabled: !!site,
  });
  const timezone = useMemo(() => clientQuery.data?.timezoneInfo.timezone, [clientQuery?.data]);
  const wkid = useMemo(() => clientQuery.data?.wkid || 4326, [clientQuery?.data]);

  return {
    ...(clientQuery?.data ?? {}),
    query: clientQuery,
    timezone,
    wkid,
    clientId: clientQuery.data?.cityId,
  };
};
